import React, { useEffect, useState, useContext } from "react";
import Breadcrumbs from "./Breadcrumb";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { ProductService } from "../../../services/product-service";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { Modal } from "react-bootstrap";
import AuthContext from "../../../context/auth-context";
import SearchList from "./SearchList";
import { GdnService } from "../../../services/gdn-service";
import Select from "react-select";

export const Listcontent = (props) => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "DISPATCH" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "DISPATCH" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }
    });
  }, [authPermission]);

  const format2 = "YYYY-MM-DD";

  const [submitloading, setSubmitLoading] = useState(true);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);
  const [filterProductId, setFilterProductId] = useState("");
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProductOption, setSelectedProductOption] = useState(null);

  const handleChangeSearchTerm = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    // if (value === "") return;
    // productSearch(value)
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const history = useHistory();

  const [dispatchNotes, setDispatchNotes] = useState([]);

  const [state, setState] = useState(false);

  const [gdnID, setGdnID] = useState();

  const handleShow4 = (e) => {
    setState({ show4: true });
    setGdnID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const getAllProducts = async () => {
      try {
        const result = await ProductService.allproductsNames();
        setProducts(result);
      } catch (err) {
        //toast
        if (err.response.data.message !== undefined) {
          notifyWarning(err.response.data.message);
        } else {
          notifyWarning("Something Wrong");
        }
      }
    };

  const dispatchesSearch = async (searchTerm) => {

    try {
      const result = await GdnService.gdnDetailsSearch(
        filterProductId, 
        searchTerm,
        rowsPerPage,
        page
      );
      setDispatchNotes(result.results);
      setDataCount(result.pagination.total);
    } catch (err) {
      console.error(err);
    }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await GdnService.gdnDelete(gdnID);

      setSubmitLoading(true);
      notify("GDN successfully deleted");
      handleClose();
      dispatchesSearch();
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  useEffect(() => {
    dispatchesSearch(searchTerm);
  }, [filterProductId, searchTerm, rowsPerPage, page, count]);

  useEffect(() => {
        getAllProducts();
    },[])
 

  const calculateHeight = () => {
    // Approximate row height + header + footer
    return rowsPerPage * 52 + 150;
  };

  const clearFilters = () => {
    getAllProducts();
    setSelectedProductOption(null);
    setFilterProductId("");
    setSearchTerm("");
    setPage(0);
    setRowsPerPage(10);
  };

  const handleMainProductFilterChange = (selectedOption, index) => {
    setSelectedProductOption(selectedOption);
    setFilterProductId(selectedOption ? selectedOption.value : "");
  };

  let ProductOptions = products.map((product) => ({
    value: product.id,
    label: product.name,
    keyword: product.name.toLowerCase(),
  }));

  const filterProductOption = (option, rawInput) => {
    const search = rawInput.toLowerCase().trim();
    const keywords = search.split(/\s+/); // split by spaces
    const optionText = option.data.keyword;
    
    return keywords.every((keyword) => optionText.includes(keyword));
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "invoice_number",
      headerName: "Invoice Number",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "publisher.name",
      headerName: "Supplier Name",
      flex: 4,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{params.row.publisher.name}</div>;
      },
    },
    {
      field: "total_price",
      headerName: "Invoice Value",
      flex: 3,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "center",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(params.value);
      },
    },
    {
      field: "sent_date",
      headerName: "Dispatch Date",
      sortable: false,
      flex: 3,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{moment(params.row.sent_date).format(format2)}</div>;
      },
    },
    {
      field: "comment",
      headerName: "Comment",
      flex: 3,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   sortable: false,
    //   flex: 2,
    //   disableClickEventBubbling: true,
    //   headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    //   renderCell: (params) => {
    //     if (params.row.status === "ACTIVE") {
    //       return (
    //         <div>
    //           <span className="badge badge-success">ACTIVE</span>
    //         </div>
    //       );
    //     } else {
    //       return (
    //         <div>
    //           {" "}
    //           <span className="badge badge-secondary">DEACTIVE</span>
    //         </div>
    //       );
    //     }
    //   },
    // },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              window.open(`${window.location.origin}/gdn-edit/${params.row.id}`, '_blank');
            }}
            style={{ cursor: "pointer" }}
            hidden={editHide}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumbs />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <h6>Goods Dispatch Note(GDN) List</h6>
            </div>

            {/* search for product */}

            <div className="row ml-5">
              <div className="col-md-4">
                  <label htmlFor="validationCustom15"></label>
                  <Select
                    options={ProductOptions}
                    onChange={handleMainProductFilterChange}
                    isClearable
                    placeholder="Filter by Product"
                    filterOption={filterProductOption}
                    value={selectedProductOption}
                  />
              </div>
              {/* search for product */}
              <div className="col-md-6 mt-2">
                <SearchList
                  handleChange={handleChangeSearchTerm}
                  searchTerm={searchTerm}
                />
              </div>
              <div className="col-md-1 mt-0">
                <div className="input-group">
                  <button
                      type="button"
                      className="btn btn-secondary shadow-none"
                      onClick={clearFilters}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>

            <div>
              <Modal
                show={state.show4}
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header>
                  <h3 className="modal-title has-icon ms-icon-round ">
                    Confirm Deletion
                  </h3>
                  <button type="button" className="close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                  </button>
                </Modal.Header>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "2vh",
                  }}
                >
                  <h6 style={{ color: "red" }}>
                    Are you sure you want to remove this item ?
                  </h6>
                </div>
                <Modal.Footer>
                  <div className="col-md-2" hidden={submitloading}>
                    <div className="spinner spinner-7">
                      <div className="bounce1" />
                      <div className="bounce2" />
                      <div className="bounce3" />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary shadow-none"
                    style={{ backgroundColor: "red" }}
                    onClick={onDelete}
                  >
                    Delete
                  </button>

                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                </Modal.Footer>
              </Modal>
            </div>

            <div className="ms-panel-body">
              <div style={{ minHeight: calculateHeight(), height: calculateHeight(), flex: "100%" }}>
                <DataGrid
                  rows={dispatchNotes}
                  columns={columns}
                  disableExtendRowFullWidth={false}
                  pageSize={rowsPerPage}
                  pagination
                  hideFooter
                  autoHeight
                />
                <TablePagination
                  component="div"
                  count={count}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Listcontent;
